export default "__VITE_PUBLIC_ASSET__fd93a685__"